import { useMediaQuery } from 'react-responsive';
import logo from './images/images-header/logo-sde-nehemia-50px.png'
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Handicapped from './images/images-header/Handicapped';
import Facebook from './images/images-header/Facebook';
import Instagram from './images/images-header/Instagram';
import HomeSVG from './images/images-home/HomeSVG';

const Header = ({isInIFrame}) => {

    const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1350px)'})
    
    const navigate = useNavigate()

    let size;

    if (isDesktopOrLaptop) {
        size = "38px";
    } else {
        size = "36px";
    }


    return (  
        <>
        {!isInIFrame &&
            <header>
                {!isDesktopOrLaptop && 
                <Handicapped size={size}/>
                }
                
                {isDesktopOrLaptop &&
                    <div className='svg-header-icon'>
                        <a style= {{width: '46px', height: '46px'}} href="https://www.facebook.com/people/%D7%A7%D7%94%D7%99%D7%9C%D7%AA-%D7%A9%D7%93%D7%94-%D7%A0%D7%97%D7%9E%D7%99%D7%94/pfbid02zrcX63rbSpMyPxfVeEmXvALa7kxTpG16furdmeKmmnDyeyYAnSUrn8wujRKxnGbkl/" rel="noreferrer" target="_blank">
                            <Facebook />
                        </a>
                        
                    </div> 
                }

                <img src={logo} className='header-logo' alt='logo' onClick={() => navigate('/')}/>
                
                {!isDesktopOrLaptop && 
                    <Navbar />
                }

                {isDesktopOrLaptop &&
                    <div className='svg-header-icon'>
                        <Handicapped size={size}/>
                    </div>
                }
            </header>
        } 
        </>   
    );

}
 
export default Header;